import Modal from "react-bootstrap/Modal";
import FormRoute from "./route/FormRoute";
import {useEffect} from "react";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import {ScheduleRouteModel} from "../../../site-apps/distribution/schedules/ScheduleModels";


const ModalCreateRoute = ({show, setShow, virtual, schedules, setSchedules}) => {
    //const startTime = `${current.format("YYYY-MM-DD")}T${item.run}`;
    //this.id = `${item.id}-${route.item.id}-${route.type}-${Math.floor(new Date(startTime).getTime() / 1000)}`;

    useEffect(() => {
        subscribeEvent("route:modalform:change", handleCustomEvent);
        return () => {
            unsubscribeEvent("route:modalform:change", handleCustomEvent);
        }
    }, [schedules])

    const handleCustomEvent = (e) => {
        let index = schedules.findIndex(r => r.id === virtual.scheduleId);
        let schedule = new ScheduleRouteModel(e.detail);
        let schedules_ = [...schedules];
        schedules_[index] = schedule;
        setSchedules(schedules_);
        unsubscribeEvent("route:modalform:change", handleCustomEvent);
    }

    const handleClose = () => {
        setShow(false);
    }

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} size="xl" aria-modal="true">
                <Modal.Body className="bg-light">
                    <div className="container-fluid">
                        <div className="row">
                            <FormRoute format="virtual" handleClose={handleClose} virtual={virtual}/>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default ModalCreateRoute;